
import { setVariantDetailProps as setVariantDetailPropsDiagram } from '@process-advisor/process-miner/processMiner/processMiner';

export type Props = {
    variant?: string;
}

export const setVariantDetailProps = ({
    variant,
}: Props) => setVariantDetailPropsDiagram({
    variant,
});


